module.exports = __webpack_public_path__ + "img/metamask-custom-token-form.3b377b13.png";